module.exports = __webpack_public_path__ + "static/img/thumb-insects-2.08b7a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-insects-2.png
// module id = 90
// module chunks = 0